<template>
    <footer class="section">
        <div class="container">
            <div class="flex">
                <div class="column vat">
                    <div class="footer-logo"><img src="@/assets/images/landing-pages/footer/logo-footer.svg" />
                    <span class="tag">Getting your business online shouldn't cost the earth</span>
                    </div>
                    <a class="btn" href="https://www.stackstatus.com/" target="_blank">
                        View system status
                    </a>
                </div>
                <div class="column reviews push-right">   
                    <div class="trustpilot">
                        <a href="https://www.trustpilot.com/review/ecowebhosting.co.uk">
                            <img src="../assets/images/trustpilot/trustpilot-logo-white.svg" />
                            <img src="../assets/images/trustpilot/trustpilot-5-stars.svg" />
                            <div class="trustscore">
                                <span>Trustscore <strong>4.9</strong> &#124; <strong>562</strong> Reviews</span>
                            </div>
                        </a>
                    </div>

                    <div class="social-icons">
                        <a href="https://www.facebook.com/EcoWebHostingUK/" rel="noopener noreferrer">
                            <img
                                v-cloak
                                src="@/assets/images/landing-pages/footer/facebook-white.svg"
                                alt="Facebook"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                        </a>
                        <a href="https://www.linkedin.com/company/eco-web-hosting-ltd" rel="noopener noreferrer">
                            <img
                                v-cloak
                                src="@/assets/images/landing-pages/footer/linkedin-white.svg"
                                alt="LinkedIn"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                        </a>
                        <a href="https://twitter.com/ecowebhostinguk" rel="noopener noreferrer">
                            <img
                                v-cloak
                                src="@/assets/images/landing-pages/footer/twitter-white.svg"
                                alt="Twitter"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                        </a>
                        <a href="https://www.instagram.com/ecowebhostinguk/" rel="noopener noreferrer">
                            <img
                                v-cloak
                                src="@/assets/images/landing-pages/footer/instagram-white.svg"
                                alt="Instagram"
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                        </a>
                    </div>
               
                </div>
                <div class="column">
                    <ul>
                        <h3>Customer tools</h3>
                        <li>
                            <a href="https://support.ecowebhosting.co.uk/">Support</a>
                        </li>
                        <li>
                            <a href="https://ecowebhosting.co.uk/cp/home">Customer Area</a>
                        </li>
                        <li>
                            <a href="https://www.stackcp.com" rel="noopener noreferrer">Hosting Control Panel</a>
                        </li>
                        <li>
                            <a href="https://vps.ecowebhosting.co.uk/">VPS control panel</a>
                        </li>
                        <li>
                            <a href="https://www.ecowebhosting.co.uk/cp/managedomains">Domains control panel</a>
                        </li>

                        <li>
                            <a href="https://www.stackmail.com" rel="noopener noreferrer">Webmail</a>
                        </li>
                    </ul>
                </div>                 

                <div class="column">
                    <ul>
                        <h3>Our Products</h3>
                        <li>
                            <router-link to="/web-hosting">
                                Web Hosting
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/reseller-hosting">
                                Reseller Hosting
                            </router-link>
                        </li>
                       
                        <li>
                            <router-link to="/managed-wordpress">
                                Managed WordPress Hosting
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/domain-names">
                                Domain Names
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/vps">
                                VPS
                            </router-link>
                        </li>
                    </ul>
                </div>
                <div class="column">
                    <ul>
                        <h3>Misc</h3>
                        <li>
                            <router-link to="/about">
                                About Us
                            </router-link>
                        </li>
                        
                        <li>
                            <a href="https://www.ecowebhosting.co.uk/blog">Blog</a>
                        </li>

                        <li>
                            <router-link to="/green-credentials">
                                Green Credentials
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/affiliate-program">
                                Affiliate Program
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/agreements">
                                Terms &amp; Conditions
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/agreements/privacy-policy">
                                Privacy Policy
                            </router-link>
                        </li>
                    </ul>
                </div>
              
                
            </div>

            <div class="bottom-bar">
                <div class="copyright">
                        &copy; Copyright Enix Ltd t/a Eco Web Hosting 2007 &mdash; {{ new Date().getFullYear() }} <br>VAT number: GB 107180052
                </div>

                <div class="footer-creds">
                    <a
                        href="https://ecologi.com/ecowebhostinglimited?r=5e19d565d36d48001886caf4"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="View our Ecologi profile"
                        
                    >
                        <img
                            alt="We offset our carbon footprint via Ecologi"
                            src="@/assets/images/landing-pages/footer/ecologi-cpw-white.svg"
                            
                        >
                    </a>
                    <a
                        href="https://tree-nation.com/profile/impact/eco-web-hosting#co2"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="position:relative;cursor:pointer;display:inline-block;z-index:999;"
                    >
                        <img
                            src="https://tree-nation.com/images/tracking/label-co2-website-black-en.png"
                            alt="CO2 Neutral website care of Tree-Nation"
                            style="width:155px;height:auto;"
                        >
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
   
</style>


<script>
export default {
    name: 'SiteFooter',
    mounted() {
        this.addAwinTracker();
    },
    methods: {
        addAwinTracker() {
            let awinScript = document.createElement('script');
            awinScript.setAttribute(
                'src',
                'https://www.dwin1.com/21391.js'
            );
            awinScript.setAttribute('async', true);
            document.body.appendChild(awinScript);
        },
    }
};
</script>

<style lang="scss" scoped>

</style>